import { Navigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

function Loading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background" data-testid="route-loading">
      <Loader2 className="h-8 w-8 animate-spin text-ztk-blue" />
    </div>
  );
}

function PendingNotice() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-ztk-navydark px-4 pt-[68px]" data-testid="pending-notice">
      <div className="max-w-md rounded-2xl border border-white/10 bg-white p-8 text-center shadow-2xl dark:bg-slate-900">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-ztk-yellow/20 text-ztk-yellow">
          <Clock className="h-7 w-7" />
        </div>
        <h1 className="font-display text-2xl font-bold text-ztk-navy dark:text-white">Konto oczekuje na zatwierdzenie</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Dziękujemy za rejestrację! Twoje konto musi zostać zatwierdzone przez administratora Izby.
          Otrzymasz powiadomienie e-mail, gdy uzyskasz dostęp do forum.
        </p>
        <Button asChild className="mt-6 bg-ztk-blue"><Link to="/">Wróć na stronę główną</Link></Button>
      </div>
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (user.role !== "admin" && user.approved === false) return <PendingNotice />;
  return children;
}

export function AdminRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
